/**
 * Historia, sala de ventas y taller: lo que el sitio viejo repartia en
 * `/nosotros`, `/sucursales`, `/contacto` y `/servicios`, que ahora redirigen
 * aca (`servicios/sitio-viejo.servicio.ts` en el backend). Los textos salen de
 * esas paginas. El centro de distribucion de Pudahuel no aparece: no atiende
 * publico.
 *
 * Pensada para entenderse de un vistazo: la banda de la portada con la foto,
 * una linea de tiempo y tarjetas con iconos. Es estatica (no se edita
 * en el panel).
 *
 * El mapa y el WhatsApp no se repiten: el pie y el boton flotante ya los
 * traen (y un boton de WhatsApp nuevo exige un origen nuevo en las metricas).
 */
import { HistoriaTienda } from '../componentes/tienda/HistoriaTienda';
import { PortadaTienda } from '../componentes/tienda/PortadaTienda';
import { TallerTienda } from '../componentes/tienda/TallerTienda';
import { VisitaTienda } from '../componentes/tienda/VisitaTienda';
import { SITIO } from '../configuracion/sitio';
import { Seo } from '../seo/Seo';
import { rutas } from '../utilidades/rutas';

const ENLACE_MAPS = `https://www.google.com/maps?cid=${SITIO.mapaCid}`;

export function NuestraTienda() {
  return (
    <>
      <Seo
        titulo="Nuestra tienda"
        descripcion={`${SITIO.nombreLargo} desde 1955 en San Diego 820, Santiago: sala de ventas, horario, contacto y taller de fabricación y afilado de herramientas.`}
        ruta={rutas.nuestraTienda()}
      />

      <PortadaTienda enlaceMaps={ENLACE_MAPS} />

      <div className="contenedor pagina tienda-pagina">
        <HistoriaTienda />
        <VisitaTienda enlaceMaps={ENLACE_MAPS} />
        <TallerTienda />
      </div>
    </>
  );
}
